import React from 'react';
import ContentLoader from 'react-content-loader';

const DetailLoader = (props) => (
  <ContentLoader
    speed={2}
    width={350}
    height={80}
    viewBox="0 0 350 80"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="84" y="8" rx="3" ry="3" width="220" height="10" />
    <rect x="84" y="32" rx="3" ry="3" width="220" height="10" />
    <rect x="84" y="57" rx="3" ry="3" width="220" height="10" />
    <circle cx="40" cy="40" r="40" />
  </ContentLoader>
);

export default DetailLoader;
